import React, { type ReactNode } from 'react';
import { StyleSheet, View } from 'react-native';
import { Text } from './Texte';
import { FondNuit } from './FondNuit';
import { t } from '../i18n';
import { colors, formes, spacing, typography } from '../theme/tokens';

export interface CarteScoreInconnuProps {
  // État d'enregistrement posé sous le texte, comme sur `CarteScore`.
  action?: ReactNode;
  testID?: string;
}

/**
 * Carte nuit d'un CV qui n'a pas été noté (optimisé par modifications). À la place de l'anneau, aucun
 * chiffre : un faux 0 ou un score inventé dirait ce que personne n'a mesuré.
 */
export function CarteScoreInconnu({ action, testID = 'score-inconnu' }: CarteScoreInconnuProps) {
  return (
    <FondNuit testID={testID} style={styles.carte}>
      <View style={styles.textes}>
        <Text testID={`${testID}-titre`} accessibilityRole="header" style={styles.titre}>
          {t('cvImprove.scoreInconnu.titre')}
        </Text>
        <Text testID={`${testID}-detail`} style={styles.detail}>
          {t('cvImprove.scoreInconnu.detail')}
        </Text>
        {action ? <View style={styles.action}>{action}</View> : null}
      </View>
    </FondNuit>
  );
}

const styles = StyleSheet.create({
  carte: { borderRadius: formes.rayon.lg, padding: spacing.lg },
  textes: { gap: spacing.xs },
  titre: { fontSize: typography.h3.size, lineHeight: typography.h3.lineHeight, fontWeight: '800', color: colors.white },
  detail: { fontSize: typography.small.size, lineHeight: typography.small.lineHeight, color: colors.blancAtenue },
  action: { alignSelf: 'flex-start', marginTop: spacing.xs },
});
